const sharePrefixes = (url: string, title: string) => ({
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  twitter: `https://twitter.com/share?text=${title}&url=${url}`,
  vk: `http://vk.com/share.php?url=${url}`,
  email: `mailto:?body=${url}&subject=${title}`,
  telegram: `https://t.me/share/url?url=${url}`,
  //odnoklassniki: `http://www.odnoklassniki.ru/dk?st.cmd=addShare&st._surl=${url}`,
  odnoklassniki: `https://connect.ok.ru/offer?url=${url}`,
  whatsapp: `https://web.whatsapp.com/send?text=${url}`,
})

export type ServiceEnum = keyof ReturnType<typeof sharePrefixes>

export const buildShareUrl = (service: ServiceEnum) => {
  const url = encodeURIComponent(window.location.href)
  const title = encodeURIComponent(document.title)
  return sharePrefixes(url, title)[service]
}
